import React from 'react';
import VehicleIdentification from '../../../../../common/components/Tables/VehicleIdentification/VehicleIdentification';

export const MemoVehicleIdentificationColumn = React.memo(VehicleIdentification);
